<div class="card">
  <div class="card-header">
    Accounts
  </div>
  <div [loadingOverlay]="isLoading" class="card-body">
    <div class="row mb-3">
      <div class="col-md-2">
        <div class="form-group">
          <label class="control-label">Customer Status</label>
          <select [(ngModel)]="selectedStatus" class="form-select">
            @for (status of customerStatuses; track status.value) {
            <option [ngValue]="status.value">{{ status.name }}</option>
            }
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Search</label>
          <input [(ngModel)]="searchText" [returnKey]="search.bind(this)"
            placeholder="Search by name, URL, phone, or ID" type="text" class="form-control" />
        </div>
      </div>
      <div class="col-md-1">
        <label class="control-label d-block">&nbsp;</label>
        <button [disabled]="isLoading" (click)="search()" class="btn btn-primary">
          <i class="fa fa-search"></i>Search
        </button>
      </div>
      <div class="col-md-6"></div>
    </div>
    <div class="card card-body bg-light">NOTE: Searching with "All Statuses" may take several seconds. Results are
      limited to 10,000.</div>

    @if (hasSearched && !isLoading && accounts.length === 0) {
    <div class="alert alert-info">
      No accounts found.
    </div>
    }

    @if (accounts.length > 0) {
    <h5>
      <i class="fa fa-search"></i>
      &nbsp;
      <span>{{ accounts.length }}</span>
      &nbsp;{{ accounts.length === 1 ? 'result' : 'results' }}
      @if (searchContextText) {
        for <span>{{ searchContextText }}</span>
      }
    </h5>
    <app-table [items]="accounts" [exportFilename]="'partner-accounts'">
      <ng-template #tableHeader>
        <tr>
          <th export sort field="CustomerId">ID</th>
          <th export sort field="Name">Name</th>
          <th export sort field="Url">Website</th>
          <th export sort field="Products">Products</th>
          <th export sort field="SignupDate">Signup Date</th>
          <th export sort field="Status">Status</th>
          <th export sort field="CsrName">CSR</th>
          <th export sort field="TeamName">Team</th>
          <th export sort field="DaysTillRenewal">Days to Renew</th>
          <th class="text-center">Reporting Dashboard</th>
        </tr>
      </ng-template>
      <ng-template #tableBody let-account>
        <tr>
          <td>{{ account.CustomerId }}</td>
          <td>{{ account.Name }}</td>
          <td style="max-width: 350px;">
            <a [externalLink]="{ url: account.Url, text: account.Url }" rel="noreferrer" style="display: block; overflow: hidden; text-overflow: ellipsis;"></a>
          </td>
          <td [innerHtml]="account.Products"></td>
          <td>{{ account.SignupDate | dateText : 'L' : true }}</td>
          <td>{{ account.Status }}</td>
          <td>{{ account.CsrName }}</td>
          <td>{{ account.TeamName }}</td>
          <td>{{ account.DaysTillRenewal }}</td>
          <td>
            <div class="d-flex gap-2 justify-content-center">
              <button (click)="openSSOLink(account)" class="btn btn-primary" title="Open SSO Link"><i
                  class="fa fa-chart-line fa-no-margin"></i></button>
              <div class="btn-group" role="group">
                <button (click)="openReadOnlySSOLink(account)" class="btn btn-secondary"
                  title="Open readonly SSO Link"><i class="fa fa-eye fa-no-margin"></i></button>
                <button (click)="copyReadOnlySSOLink(account)" class="btn btn-outline-secondary"
                  title="Copy readonly SSO Link"><i class="fa fa-link fa-no-margin"></i></button>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </app-table>
    }
  </div>
</div>